<template>
  <div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="700px" :close-on-click-modal="false"
      @close="closeDialog">
      <el-form :model="form" label-position="top">

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Group name">
              <el-input v-model="form.monthlyChargeGroup" placeholder="Ex. G-BA-000" autocomplete="off"
                :disabled="isEditMode || selectedMembers.length > 0"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="Search Member Code">
              <el-input v-model="membercode" placeholder="Type code e.g., BA-000" autocomplete="off" clearable
                @keyup.enter.native="handleSearch">
                <el-button slot="append" icon="el-icon-search" :loading="loading" @click="handleSearch"></el-button>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-card v-if="searchResult" shadow="never" style="margin-bottom: 20px; background-color: #f5f7fa;">
          <div slot="header" class="clearfix">
            <span><strong>Found Member</strong></span>

            <el-button style="float: right; padding: 3px 0" type="text" icon="el-icon-plus" :loading="adding"
              @click="addMemberToGroup" v-if="searchResult.checkLinked === 'NO-LINK'">
              Add to Group Now
            </el-button>
          </div>
          <el-descriptions :column="2" border size="small">
            <el-descriptions-item label="Name">{{ searchResult.name }}</el-descriptions-item>
            <el-descriptions-item label="Member Code">{{ searchResult.memberCode }}</el-descriptions-item>
            <el-descriptions-item label="Status">
              <el-tag :type="searchResult.checkLinked === 'NO-LINK' ? 'success' : 'danger'" size="mini">
                {{ searchResult.checkLinked }}
              </el-tag>
            </el-descriptions-item>
          </el-descriptions>
        </el-card>

        <div v-if="selectedMembers.length > 0">
          <div style="margin-bottom: 10px; font-weight: bold;">
            <i class="el-icon-s-custom"></i> Group Members ({{ selectedMembers.length }})
          </div>

          <el-table :data="selectedMembers" style="width: 100%" border size="small" max-height="250"
            v-loading="listLoading">
            <el-table-column prop="memberCode" label="Member Code" width="120"></el-table-column>
            <el-table-column prop="monthlyChargeGroup" label="Group name" min-width="150">
              <template slot-scope="scope">
                {{ scope.row.monthlyChargeGroup || '-' }}
              </template>
            </el-table-column>
            <el-table-column label="Action" width="80" align="center">
              <template slot-scope="scope">
                <el-button type="danger" icon="el-icon-delete" circle size="mini"
                  @click="handleRemoveClick(scope.row)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">Close</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// Import ฟังก์ชัน API ที่ต้องใช้
import {
  searchMonthlyfeeGroupByMemberCode,
  createMonthlyfeeGroup,
  getMonthlyfeeGroupBy,       // ดึงรายชื่อ
  deleteMemberMonthlyfeeGroup 
} from '@/api/linkgroup'

export default {
  data() {
    return {
      dialogFormVisible: false,
      loading: false,     // search loading
      adding: false,      // add button loading
      listLoading: false, // table loading

      membercode: "",

      form: {
        monthlyChargeGroup: '',
      },

      isEditMode: false,
      searchResult: null,
      selectedMembers: [], // List นี้จะดึงจาก API
    }
  },
  computed: {
    dialogTitle() {
      return this.isEditMode ? `Manage Group: ${this.form.monthlyChargeGroup}` : 'Create New Group'
    }
  },
  methods: {
    // รับค่า existingGroupName มาเพื่อเปิดโหมดแก้ไข
    show(existingGroupName = null) {
      this.resetForm()
      if (existingGroupName) {
        this.form.monthlyChargeGroup = existingGroupName
        this.isEditMode = true
        // เปิดมาปุ๊บ ดึงข้อมูลสมาชิกในกลุ่มทันที
        this.fetchGroupMembers()
      } else {
        this.isEditMode = false
      }

      this.dialogFormVisible = true
    },

    closeDialog() {
      this.dialogFormVisible = false
    },

    resetForm() {
      this.membercode = ""
      this.searchResult = null
      this.selectedMembers = []
      this.form.monthlyChargeGroup = ""
      this.adding = false
      this.isEditMode = false
      this.listLoading = false
    },

    // ฟังก์ชันดึงสมาชิกในกลุ่ม (ตามที่พี่วาวขอ)
    fetchGroupMembers() {
      if (!this.form.monthlyChargeGroup) return;

      this.listLoading = true;
      getMonthlyfeeGroupBy(this.form.monthlyChargeGroup)
        .then(res => {
          this.listLoading = false;
          if (res.result) {
            this.selectedMembers = res.data || [];
          }
        })
        .catch(err => {
          console.error(err);
          this.listLoading = false;
        });
    },

    onInput() {
      if (this.inputTimeout) clearTimeout(this.inputTimeout)
      this.inputTimeout = setTimeout(() => {
        this.getMemberCode()
      }, 1200)
    },

    handleSearch() {
      if (!this.membercode) {
        this.$message.warning('Please enter member code');
        return;
      }

      this.loading = true
      this.searchResult = null // เคลียร์ผลเก่าก่อนหาใหม่

      searchMonthlyfeeGroupByMemberCode(this.membercode)
        .then(response => {
          this.loading = false
          const { result, data } = response

          if (result) {
            this.searchResult = data
          } else {
            this.searchResult = null
            this.$message.info('Member not found'); // แจ้งหน่อยถ้าหาไม่เจอ
          }
        })
        .catch(() => {
          this.loading = false
          this.searchResult = null
        })
    },

    addMemberToGroup() {
      if (!this.searchResult) return;
      if (!this.form.monthlyChargeGroup) {
        this.$message.error('Please enter Group Name first');
        return;
      }

      // เช็คซ้ำจาก list ที่ดึงมาจาก API
      const isExist = this.selectedMembers.some(m => m.enduserId === this.searchResult.enduserId);
      if (isExist) {
        this.$message.warning('This member is already in the group.');
        return;
      }

      this.adding = true;

      const payload = {
        monthlyChargeGroup: this.form.monthlyChargeGroup,
        enduserId: this.searchResult.enduserId
      };

      createMonthlyfeeGroup(payload)
        .then(() => {
          this.$message.success(`Added ${this.searchResult.name} successfully!`);

          // Add เสร็จแล้ว ดึงข้อมูลใหม่ทันที
          this.fetchGroupMembers();

          // แจ้ง Parent
          this.$emit('saved');

          // Reset Search
          this.membercode = "";
          this.searchResult = null;
        })
        .catch(error => {
          console.error(error);
          this.$message.error('Failed to add member.');
        })
        .finally(() => {
          this.adding = false;
        });
    },

    handleRemoveClick(row) {
      this.$confirm(`Are you sure you want to remove ${row.name || 'this member'}?`, 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.removeMember(row);
      }).catch(() => { });
    },

    // ฟังก์ชันลบสมาชิก
    removeMember(row) {
      console.log(row)
      deleteMemberMonthlyfeeGroup(row.enduserId)
        .then(() => {
          this.$message.success('Member removed');

          // ลบเสร็จ ดึงข้อมูลใหม่ทันที
          this.fetchGroupMembers();

          // แจ้ง Parent
          this.$emit('saved');
        })
        .catch(err => {
          console.error(err);
          this.$message.error('Failed to remove member');
        });
    }
  },
}
</script>

<style lang="scss" scoped>
.el-descriptions {
  margin-top: 10px;
}
</style>